<div
  class="container"
  [ngStyle]="{ 'height.px': size(), 'width.px': size(), 'min-height.px': size(), 'min-width.px': size() }"
>
  <div class="status"></div>
</div>
